import api from './api';

export default {
    async getAccount(token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/accounts`, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao enviar legendas:', error);
            throw error;
        }
    },
}
